import TrackingDataContext from 'contexts/TrackingDataContext';
import { useContext } from 'react';
import NavBarClick, { EngagementTypes } from 'lib/Tracking/NavBarClick';
import useEvents from 'lib/hooks/useEvents';

export function useLog(): (engagementType: EngagementTypes) => void {
  const { source_page: sourcePage } = useContext(TrackingDataContext);
  const logger = useEvents();

  return (engagementType: EngagementTypes): void => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const event = new NavBarClick(sourcePage!, engagementType);

    logger.log(event.toJSON());
  };
}
